type Prompt = 'radius-outcome' | 'satellite-upgrade';

export function isPromptDismissed(prompt: Prompt): boolean {
  try { return window.sessionStorage.getItem(`drawonamap.dismissed.${prompt}`) === 'true'; }
  catch { return false; }
}

export function dismissPrompt(prompt: Prompt): void {
  try { window.sessionStorage.setItem(`drawonamap.dismissed.${prompt}`, 'true'); }
  catch {}
}
